const CONSTANTS = {
  PATTERN: {
    ONLY_CALACTOR: /[^!-/:-@¥[-`{-~]+/,
    ONLY_NUMBER: /^\d+$/,
    ONLY_HIRAGANA: /^[ぁ-んー]+$/,
    // メール形式チェックは emailValidation.ts の EMAIL_PATTERN / isValidEmail に統一（CRM と同一ルール）。
    // 旧 PATTERN.EMAIL / EMAIL_NOT_RFC は廃止し、各呼び出し元が emailValidation.ts を直接参照する。
    PASSWORD: /^.*(?=.{8,50})(?=.*[a-zA-Z])(?=.*\d).*$/,
    INSTAGRAM: /^[a-zA-Z0-9_.]+$/,
  },
  MAX_LENGTH: {
    SEARCH_FORM_TEXT: 500,
    EMAIL: 255,
    PASSWORD: 20,
  },

  USER_SESSION_KEY: "userSession",
};
export default CONSTANTS;
